let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ijQ6l")).then(() => parcelRequire('9mF1p'));